"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInList = exports.shuffleList = exports.areItemsDistinct = exports.join = exports.sumList = exports.sortList = exports.filterList = exports.countByType = exports.concatArrays = exports.emptyList = exports.oneFromList = void 0;
const numbers_1 = require("../numbers");
function oneFromList({ list = [] }) {
    return list[(0, numbers_1.integerBetween)({ minInt: 0, maxInt: list.length - 1 })];
}
exports.oneFromList = oneFromList;
function emptyList() {
    return [];
}
exports.emptyList = emptyList;
function concatArrays({ list = [] }) {
    let array = [];
    for (const item of list)
        array = array.concat(item);
    return array;
}
exports.concatArrays = concatArrays;
function countByType({ list = [], allowedTypes = [] }) {
    const initial = Object.fromEntries(allowedTypes.map((t) => [t, 0]));
    return Object.fromEntries(Object.entries(list.reduce((soFar, item) => {
        var _a;
        var _b;
        (_a = soFar[_b = item.type]) !== null && _a !== void 0 ? _a : (soFar[_b] = 0);
        soFar[item.type] += 1;
        return soFar;
    }, initial)).sort((a, b) => a[0].localeCompare(b[0])));
}
exports.countByType = countByType;
function filterList({ list = [], filterField = '' }) {
    return filterField ? list[0].filter((v) => { var _a; return (_a = v[filterField]) === null || _a === void 0 ? void 0 : _a.isTrue; }) : list;
}
exports.filterList = filterList;
function sortList({ list = [], numeric = false, reverse = false }) {
    const sorted = Array.isArray(list[0]) ? [...list[0]] : [...list];
    if (numeric) {
        sorted.sort((a, b) => a - b);
    }
    else {
        sorted.sort();
    }
    return reverse ? sorted.reverse() : sorted;
}
exports.sortList = sortList;
function sumList({ list = [], operator = '+' }) {
    const arrayToSum = Array.isArray(list[0]) ? [...list[0]] : [...list];
    const answer = arrayToSum.reduce((a, b) => {
        switch (operator) {
            case '+':
                return a + b;
            case '-':
                return a - b;
            case '*':
                return a * b;
            case '/':
                return a / b;
            default:
                return 0;
        }
    });
    return answer;
}
exports.sumList = sumList;
function join({ list = [], separator = ',' }) {
    const arrayToJoin = Array.isArray(list[0]) ? [...list[0]] : [...list];
    return arrayToJoin.join(separator);
}
exports.join = join;
function areItemsDistinct({ list = [] }) {
    const arrayToUse = Array.isArray(list[0]) ? [...list[0]] : [...list];
    const jsonList = arrayToUse.map((item) => JSON.stringify(item));
    const set = new Set(jsonList);
    return jsonList.length === set.size;
}
exports.areItemsDistinct = areItemsDistinct;
function shuffleList({ list = [] }) {
    const toShuffle = Array.isArray(list[0]) ? [...list[0]] : [...list];
    const shuffled = [];
    while (toShuffle.length) {
        const index = Math.floor(Math.random() * toShuffle.length);
        shuffled.push(toShuffle.splice(index, 1)[0]);
    }
    return shuffled;
}
exports.shuffleList = shuffleList;
function isInList({ item, list = [], compareAsJSON = false }) {
    const arrayToUse = Array.isArray(list[0]) ? [...list[0]] : [...list];
    return arrayToUse.some((el) => compareAsJSON
        ? JSON.stringify(el) === JSON.stringify(item)
        : el === item);
}
exports.isInList = isInList;
